<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>

  <mat-tab-group>
    <mat-tab label="Details">
    <div [formGroup]="form1" class="forms w-100 d-block" style="padding-top:15px;">
      <div class="row m-0">

        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>

        <!-- Metadata -->
        <div class="col-lg-12"><h5>Template Info</h5></div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="templateName" id="templateName" type="text" pInputText>
            <label for="templateName">Template Name</label>
            @for (validation of validationMessages.templateName; track validation) {
              <span>
                @if (form1.get('templateName').hasError(validation.type) && (form1.get('templateName').dirty || form1.get('templateName').touched)) {
                  <small class="p-invalid">{{validation.message}}</small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown class="w-100" [options]="statuses" formControlName="isActive" optionLabel="name"
            optionValue="value" placeholder="Status"></p-dropdown>
            <label for="isActive">Active</label>
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <textarea formControlName="templateDescription" id="templateDescription" [rows]="2" pInputTextarea></textarea>
            <label for="templateDescription">Description</label>
          </span>
        </div>

        <!-- Default Values -->
        <div class="col-lg-12"><h5>Default Values (copied to new proformas)</h5></div>

        <div class="col-lg-4">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="defaultMgmtFeePCT" id="defaultMgmtFeePCT" type="number" pInputText>
            <label for="defaultMgmtFeePCT">Mgmt Fee %</label>
          </span>
        </div>

        <div class="col-lg-4">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="defaultInitialTermMonths" id="defaultInitialTermMonths" type="number" pInputText>
            <label for="defaultInitialTermMonths">Initial Term (months)</label>
          </span>
        </div>

        <div class="col-lg-4">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="defaultSubsequentTermMonths" id="defaultSubsequentTermMonths" type="number" pInputText>
            <label for="defaultSubsequentTermMonths">Subsequent Term (months)</label>
          </span>
        </div>

        <div class="col-lg-4">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="defaultFreeDepartureCleanNUM" id="defaultFreeDepartureCleanNUM" type="number" pInputText>
            <label for="defaultFreeDepartureCleanNUM">Free Departure Cleans</label>
          </span>
        </div>

        <div class="col-lg-4">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="defaultFreeCarDaysNUM" id="defaultFreeCarDaysNUM" type="number" pInputText>
            <label for="defaultFreeCarDaysNUM">Free Car Days</label>
          </span>
        </div>

        <div class="col-lg-4">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="defaultSignCreditAMT" id="defaultSignCreditAMT" type="number" pInputText>
            <label for="defaultSignCreditAMT">Sign Credit $</label>
          </span>
        </div>

        <div class="col-lg-4">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="defaultRemodelCreditAMT" id="defaultRemodelCreditAMT" type="number" pInputText>
            <label for="defaultRemodelCreditAMT">Remodel Credit $</label>
          </span>
        </div>

        <div class="col-lg-4">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="defaultUpgradeCredit" id="defaultUpgradeCredit" type="number" pInputText>
            <label for="defaultUpgradeCredit">Upgrade Credit $</label>
          </span>
        </div>

        <div class="col-lg-4">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="defaultMgmtFeeCreditAMT" id="defaultMgmtFeeCreditAMT" type="number" pInputText>
            <label for="defaultMgmtFeeCreditAMT">Mgmt Fee Credit $</label>
          </span>
        </div>

        <div class="col-lg-4">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="defaultOtherCreditAMT" id="defaultOtherCreditAMT" type="number" pInputText>
            <label for="defaultOtherCreditAMT">Other Credit $</label>
          </span>
        </div>

        <!-- Slider Guardrails -->
        <div class="col-lg-12"><h5>Calculator Slider Guardrails</h5></div>

        <div class="col-lg-12"><h6>Properties</h6></div>
        <div class="col-lg-4">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="propertiesMin" id="propertiesMin" type="number" pInputText>
            <label for="propertiesMin">Min</label>
          </span>
        </div>
        <div class="col-lg-4">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="propertiesMax" id="propertiesMax" type="number" pInputText>
            <label for="propertiesMax">Max</label>
          </span>
        </div>
        <div class="col-lg-4">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="propertiesDefault" id="propertiesDefault" type="number" pInputText>
            <label for="propertiesDefault">Default</label>
          </span>
        </div>

        <div class="col-lg-12"><h6>Term Length</h6></div>
        <div class="col-lg-3">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="termLengthMin" id="termLengthMin" type="number" pInputText>
            <label for="termLengthMin">Min</label>
          </span>
        </div>
        <div class="col-lg-3">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="termLengthMax" id="termLengthMax" type="number" pInputText>
            <label for="termLengthMax">Max</label>
          </span>
        </div>
        <div class="col-lg-3">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="termLengthStep" id="termLengthStep" type="number" pInputText>
            <label for="termLengthStep">Step</label>
          </span>
        </div>
        <div class="col-lg-3">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="termLengthDefault" id="termLengthDefault" type="number" pInputText>
            <label for="termLengthDefault">Default</label>
          </span>
        </div>

        <div class="col-lg-12"><h6>Owner Days</h6></div>
        <div class="col-lg-4">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="ownerDaysMin" id="ownerDaysMin" type="number" pInputText>
            <label for="ownerDaysMin">Min</label>
          </span>
        </div>
        <div class="col-lg-4">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="ownerDaysMax" id="ownerDaysMax" type="number" pInputText>
            <label for="ownerDaysMax">Max</label>
          </span>
        </div>
        <div class="col-lg-4">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="ownerDaysDefault" id="ownerDaysDefault" type="number" pInputText>
            <label for="ownerDaysDefault">Default</label>
          </span>
        </div>

        <div class="col-lg-12"><h6>Owner Cleanings</h6></div>
        <div class="col-lg-4">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="ownerCleaningsMin" id="ownerCleaningsMin" type="number" pInputText>
            <label for="ownerCleaningsMin">Min</label>
          </span>
        </div>
        <div class="col-lg-4">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="ownerCleaningsMax" id="ownerCleaningsMax" type="number" pInputText>
            <label for="ownerCleaningsMax">Max</label>
          </span>
        </div>
        <div class="col-lg-4">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="ownerCleaningsDefault" id="ownerCleaningsDefault" type="number" pInputText>
            <label for="ownerCleaningsDefault">Default</label>
          </span>
        </div>

        <div class="col-lg-12"><h6>Rental Car Days</h6></div>
        <div class="col-lg-4">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="rentalCarDaysMin" id="rentalCarDaysMin" type="number" pInputText>
            <label for="rentalCarDaysMin">Min</label>
          </span>
        </div>
        <div class="col-lg-4">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="rentalCarDaysMax" id="rentalCarDaysMax" type="number" pInputText>
            <label for="rentalCarDaysMax">Max</label>
          </span>
        </div>
        <div class="col-lg-4">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="rentalCarDaysDefault" id="rentalCarDaysDefault" type="number" pInputText>
            <label for="rentalCarDaysDefault">Default</label>
          </span>
        </div>

        <div class="col-lg-12"><h6>Unit Condition</h6></div>
        <div class="col-lg-4">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="unitConditionDefault" id="unitConditionDefault" type="number" pInputText>
            <label for="unitConditionDefault">Default</label>
          </span>
        </div>

        <!-- Fee Formula -->
        <div class="col-lg-12"><h5>Dynamic Fee Formula</h5></div>

        <div class="col-lg-4">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="baseMgmtFeePCT" id="baseMgmtFeePCT" type="number" step="0.01" pInputText>
            <label for="baseMgmtFeePCT">Base Mgmt Fee %</label>
          </span>
        </div>

        <div class="col-lg-4">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="perPropertyDiscountPCT" id="perPropertyDiscountPCT" type="number" step="0.01" pInputText>
            <label for="perPropertyDiscountPCT">Per Property Discount %</label>
          </span>
        </div>

        <div class="col-lg-4">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="perTermMonthDiscountPCT" id="perTermMonthDiscountPCT" type="number" step="0.01" pInputText>
            <label for="perTermMonthDiscountPCT">Per Term Month Discount %</label>
          </span>
        </div>

        <div class="col-lg-4">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="mgmtFeeFloorPCT" id="mgmtFeeFloorPCT" type="number" step="0.01" pInputText>
            <label for="mgmtFeeFloorPCT">Fee Floor %</label>
          </span>
        </div>

        <div class="col-lg-4">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="mgmtFeeCeilingPCT" id="mgmtFeeCeilingPCT" type="number" step="0.01" pInputText>
            <label for="mgmtFeeCeilingPCT">Fee Ceiling %</label>
          </span>
        </div>

      </div>
    </div>
    <hr>
      <div class="row m-0">
        <div class="col-lg-12">
          <div class="btn-group">
            <div class="button-group">
              @if (proformaTemplateId) {
                <button pButton class="btn-delete p-button-outlined p-button-danger"
                (click)="onFormDelete()">Delete</button>
              }
            </div>

            <div class="button-group">
              <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
              @if (!proformaTemplateId) {
                <button pButton class="btn-addt p-button" (click)="formAdd()">Add</button>
              }

              @if (proformaTemplateId) {
                <button pButton  class="btn-upt p-button" (click)="formUpdate()">Update</button>
              }
            </div>
          </div>
        </div>
      </div>
    </mat-tab>

    @if (proformaTemplateId) {
      <mat-tab label="Default Expenses">
        <div style="padding-top:15px;">
          <p-table [value]="expenses" styleClass="p-datatable-sm p-datatable-striped" [autoLayout]="true">
            <ng-template pTemplate="caption">
              <h5 style="display:inline;">Default Expense Line Items</h5>
              <small style="margin-left:10px;">These are copied to new proformas when this template is applied.</small>
            </ng-template>
            <ng-template pTemplate="header">
              <tr>
                <th>Fee Type</th>
                <th>Name</th>
                <th>Qty</th>
                <th>Amount</th>
                <th>Percent</th>
                <th>Frequency</th>
                <th style="width:80px;"></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-expense>
              <tr>
                <td>{{getFeeTypeName(expense.feeType)}}</td>
                <td>{{expense.name}}</td>
                <td>{{expense.quantity}}</td>
                <td>{{toCurrency(expense.expenseAmnt)}}</td>
                <td>{{toPercent(expense.expensePct)}}</td>
                <td>{{getFreqName(expense.expenseFreq)}}</td>
                <td>
                  <i class="pi pi-pencil" style="color:blue;cursor:pointer;margin-right:10px;" (click)="editExpense(expense)"></i>
                  <i class="pi pi-trash" style="color:red;cursor:pointer;" (click)="deleteExpense(expense)"></i>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr><td colspan="7" style="text-align:center;">No default expenses configured.</td></tr>
            </ng-template>
          </p-table>

          <div style="margin-top:15px; padding:10px; border:1px solid #ddd; border-radius:5px;">
            <h6>@if (editingExpenseId) { Edit Expense } @else { Add Expense }</h6>
            <div [formGroup]="expenseForm" class="row m-0">
              <div class="col-lg-3">
                <span class="p-float-label w-100 mb-3">
                  <p-dropdown class="w-100" [options]="feeTypes" formControlName="feeType" optionLabel="name"
                    optionValue="value" placeholder="Fee Type" appendTo="body"></p-dropdown>
                  <label>Fee Type</label>
                </span>
              </div>
              <div class="col-lg-3">
                <span class="p-float-label w-100 mb-3">
                  <input formControlName="name" type="text" pInputText>
                  <label>Name</label>
                </span>
              </div>
              <div class="col-lg-1">
                <span class="p-float-label w-100 mb-3">
                  <input formControlName="quantity" type="number" pInputText>
                  <label>Qty</label>
                </span>
              </div>
              <div class="col-lg-2">
                <span class="p-float-label w-100 mb-3">
                  <input formControlName="expenseAmnt" type="number" step="0.01" pInputText>
                  <label>Amount $</label>
                </span>
              </div>
              <div class="col-lg-2">
                <span class="p-float-label w-100 mb-3">
                  <input formControlName="expensePct" type="number" step="0.01" pInputText>
                  <label>Percent</label>
                </span>
              </div>
              <div class="col-lg-3">
                <span class="p-float-label w-100 mb-3">
                  <p-dropdown class="w-100" [options]="expenseFreqs" formControlName="expenseFreq" optionLabel="name"
                    optionValue="value" placeholder="Frequency" appendTo="body"></p-dropdown>
                  <label>Frequency</label>
                </span>
              </div>
              <div class="col-lg-4">
                <span class="p-float-label w-100 mb-3">
                  <input formControlName="description" type="text" pInputText>
                  <label>Description</label>
                </span>
              </div>
              <div class="col-lg-5">
                @if (editingExpenseId) {
                  <button pButton class="p-button p-button-sm" (click)="updateExpense()" style="margin-right:5px;">Update</button>
                  <button pButton class="p-button-text p-button-sm" (click)="cancelEditExpense()">Cancel</button>
                } @else {
                  <button pButton class="p-button-outlined p-button-sm" (click)="addExpense()">Add Expense +</button>
                }
              </div>
            </div>
          </div>
        </div>
      </mat-tab>

      <mat-tab label="History">
        <div style="padding-top:15px;">
          <app-audit-list [auditUrl]="'proforma-templates/' + proformaTemplateId + '/audit'"></app-audit-list>
        </div>
      </mat-tab>
    }
  </mat-tab-group>
</div>
